import selectn  from 'selectn'
import typeOf   from './typeOf'

/**
* function to translate keys into their respective languages
* espn.i18n.translations
**/

function translate( edition = {}, transObj = '', params = {} ) {

  if( process.browser ) {
    const search = selectn( 'location.search', window ) || ''
    if( search.indexOf('_translate=true') !== -1 ) {
      return '{{{'+transObj+'}}}'
    }
  }

  const translations  = selectn( 'translations', edition ) || {}
  const tranObjType   = typeOf( transObj ) || ''
  let key             = ''
  let translation     = ''

  // direct translation
  if ( tranObjType === 'string' ) {
    key = transObj

  // variable translation
  } else if( tranObjType === 'object' ) {

    key = transObj['key'] || ''
    for (let k in transObj) {
      if ( transObj.hasOwnProperty( k ) && k !== 'key' ) {
        key = key + '_%{' + k + '}'
      }
    }

  } else if ( tranObjType === 'number' ) {
    translation = transObj
  }

  if ( key ) {

    const phrase = translations[key] || ''

    if( phrase ) {

      if ( tranObjType === 'string' ) {
        translation = phrase

      } else if ( tranObjType === 'object' ) {
        translation = phrase

        // find variable placeholders and replace with actual values
        const varArr = translation.match(/[%|\$]\{(\w+)\}/g) || []
        const mapLen = varArr.length
        for (let i = 0; i < mapLen; i++) {
          const varValue = varArr[i].replace(/[%|\$]|{|}/g,'')
          translation = translation.replace( varArr[i], transObj[ varValue ] || varArr[i] )
        }
      }

      if ( typeOf( params ) === 'object' ) {
        const varArr = translation.match(/\$\{(\w+)\}/g) || []
        const mapLen = varArr.length
        for (let i = 0; i < mapLen; i++) {
          const varValue = varArr[i].replace(/\$|{|}/g,'')
          translation = translation.replace( varArr[i], params[ varValue ] || varArr[i] )
        }
      }

    } else {
      // don't show null, show something clever here ie, show cleaned up key
      // there are fallbacks by locale in the getLabel method
      translation = key
    }
  }

  // prevent translation process from returning null and potentially causing NPEs
  if ( !translation && key ) {
    translation = key
  } else if ( !translation && !key) {
    translation = ''
  }

  return translation
}

export default translate

/*

For documentation on how to use this file:
https://confluence.espn.com/pages/viewpage.action?pageId=18098169

Usage:

  Direct literal translation

    translate( edition, 'hello' )

    In translate tool:
      hello       Hola

    Returns: String
      "Hola"

  Using variables in a translation

    const groupTranslation = {
      key :     'groupStandings',
      group :     'GROUP A',
      season :    'YEAR',
    }

    // the key that will show up in the translate tool is the key you pass in plus the variables like groupStandings_%{group}_%{season}

    translate( edition, groupTranslation )

    In translate tool:
      groupStandings_%{group}_%{season}   Posciones de %{group} en %{season}

    Returns: String
      "Posiciones de GROUP A en YEAR"

  Using placeholders in translations

    const paramsdata = {
      displayName :   'DISPLAY NAME',
      readableDate :  'READABLE DATE'
    }

    translate( edition, 'thereAreNoEventsByDisplayNameByDate', paramsdata )

    In translate tool:
      thereAreNoEventsByDisplayNameByDate   Posciones de ${displayName} en ${readableDate}

    Returns: String
      "Posiciones de DISPLAY NAME en READABLE DATE"

*/



// WEBPACK FOOTER //
// ../app/lib/utils/translate.js